import { render, staticRenderFns } from "./Object.vue?vue&type=template&id=50c4b44c&scoped=true"
import script from "./Object.vue?vue&type=script&lang=js"
export * from "./Object.vue?vue&type=script&lang=js"
import style0 from "./Object.vue?vue&type=style&index=0&id=50c4b44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c4b44c",
  null
  
)

export default component.exports